import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import PlanBanner from '../shared/PlanBanner';
import SellerInstallPrompt from '../shared/SellerInstallPrompt';
import NotificationAlerts from '../shared/NotificationAlerts';

export default function DashboardLayout() {
  // Feb 2026 mobile-first refactor: on <lg the Sidebar is a slide-in drawer
  // controlled by `mobileOpen`. Desktop (≥1024px) keeps the sticky 240px
  // sidebar unchanged. Any route change auto-closes the drawer so the seller
  // isn't stuck with an overlay after navigating.
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setMobileOpen(false); }, [pathname]);

  return (
    <div className="flex min-h-screen bg-fab-base">
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar onToggle={() => setMobileOpen(true)} />
        <PlanBanner />
        <main className="flex-1 p-3 sm:p-4 lg:p-6 overflow-auto" data-testid="dashboard-main">
          <Outlet />
        </main>
      </div>
      <SellerInstallPrompt />
      <NotificationAlerts />
    </div>
  );
}
